module.exports = __webpack_public_path__ + "media/product/week-3-0cc16022.png";